import GenerateEnum from '../generateEnum.js'
import { getLabelText } from '../utils.js'

export const APPLICATION_TYPE = GenerateEnum({
  LINK_SAFE: {
    value: 1,
    label: 'LinkSafe'
  },
  PRODUCT_PACKAGING_LABEL: {
    value: 2,
    label: getLabelText({
      key: 'remote.productLabel.productPackagingLabel',
      text: '产品包装标签'
    })
  },
  EXTERNAL_ORIENTATION: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.appearanceSearch',
      text: '外观检索'
    })
  },
  VAT_VALIDITY_CHECK: {
    value: 4,
    label: getLabelText({
      key: 'layouts.routeMenuName.vatValidityCheck',
      text: 'VAT有效性查询'
    })
  },
  EPR_VALIDITY_CHECK: {
    value: 5,
    label: getLabelText({
      key: 'layouts.routeMenuName.eprValidityCheck',
      text: 'EPR有效性查询'
    })
  },
  EORI_VALIDITY_CHECK: {
    value: 6,
    label: getLabelText({
      key: 'layouts.routeMenuName.eoriValidityCheck',
      text: 'EORI有效性查询'
    })
  },
  CDS_ACCOUNT_VALIDATION: {
    value: 7,
    label: getLabelText({
      key: 'layouts.routeMenuName.cdsAccountVerification',
      text: 'CDS账户校验'
    })
  },
  CURRENCY_EXCHANGE: {
    value: 8,
    label: getLabelText({
      key: 'remote.common.exchangeRateConversion',
      text: '汇率换算'
    })
  },
  EXPERIENCE_TAX_OUTSIDE: {
    value: 9,
    label: getLabelText({
      key: 'remote.common.ExperienceCalculationOverseas',
      text: '体验算税（境外）'
    })
  },
  EXPERIENCE_TAX_INSIDE: {
    value: 10,
    label: getLabelText({
      key: 'remote.common.ExperienceCalculationDomestic',
      text: '体验算税（国内）'
    })
  },
  EXCEPTIONAL_TRADEMARK_QUERY: {
    value: 11,
    label: getLabelText({
      key: 'remote.application.exceptionalTrademarkQuery',
      text: '异常商标查询'
    })
  },
  AI_TRADEMARK_NAMING: {
    value: 12,
    label: getLabelText({
      key: 'remote.application.aiTrademarkNaming',
      text: 'AI商标起名'
    })
  },
  CLASSIFICATION_QUERY: {
    value: 13,
    label: getLabelText({
      key: 'layouts.routeMenuName.categorySearch',
      text: '分类查询'
    })
  },
  US_TRADEMARK_QUERY: {
    value: 14,
    label: getLabelText({
      key: 'remote.common.unitedStatesTrademarkSwornInquiry',
      text: '美国商标宣誓查询'
    })
  },
  // 商标查询、香港公司核名、亚马逊绿标查询
  TRADEMARK_QUERY: {
    value: 15,
    label: getLabelText({
      key: 'remote.application.trademarkQuery',
      text: '商标查询'
    })
  },
  // 香港公司核名
  HKCOMPANY_NAME_VERIFICATION: {
    value: 16,
    label: getLabelText({
      key: 'remote.application.hkCompanyNameVerification',
      text: '香港公司核名'
    })
  },
  // 亚马逊绿标查询
  AMAZON_GREEN_LABEL_QUERY: {
    value: 17,
    label: getLabelText({
      key: 'remote.application.amazonGreenLabelQuery',
      text: '亚马逊绿标查询'
    })
  },
  MILLION_SELLER_CERT: {
    value: 19,
    label: '百万美金卖家认证',
  },
  // 小O首页埋点应用类型，前后端固定使用同一编号。
  XIAO_O: {
    value: 18,
    label: getLabelText({
      key: 'remote.application.xiaoO',
      text: '小O'
    })
  },
  // 小欧对话内发起在线咨询的埋点应用类型，仅统计 AI 对话页转人工入口。
  ONLINE_CONSULTATION: {
    value: 20,
    label: getLabelText({
      key: 'remote.application.onlineConsultation',
      text: '在线咨询'
    })
  },
  LOGIN: {
    value: 1000,
    label: '登录，非应用'
  },
  APP_CLICK: {
    value: 1001,
    label: '应用中心点击，非应用'
  },
})

export const SHOW_APPLICATION_TYPE = APPLICATION_TYPE.getEnumFilter('ONLINE_CONSULTATION', 'LOGIN', 'APP_CLICK')

// 应用数据分析筛选项包含非应用中心入口的在线咨询埋点。
export const APPLICATION_ANALYSIS_TYPE = APPLICATION_TYPE.getEnumFilter('LOGIN', 'APP_CLICK')

// 小O两个首页入口的来源标识，用于把点击与对话页加载成功事件关联起来。
export const XIAO_O_ENTRY_SOURCE = Object.freeze({
  HEADER: 'header',
  FLOATING: 'floating'
})

// 来源参数统一维护，避免不同商户端和共享对话页使用不一致的地址参数。
export const XIAO_O_ENTRY_SOURCE_QUERY_KEY = 'xiaoOSource'

// 小O首页埋点动作类型，用于从统一映射中获取对应事件编号。
export const XIAO_O_TRACKING_ACTION = Object.freeze({
  EXPOSURE: 'exposure',
  CLICK: 'click',
  PAGE_OPEN_SUCCESS: 'pageOpenSuccess'
})

/* 
定义事件跟踪点类型枚举
========== LinkSafe 事件 (1-39) ==========
==========产品包装标签(产品标签)事件(101-117) ==========
==========外观检索 事件(201-206) ==========
========== VAT有效性查询 事件(301-303) ==========
========== EPR有效性查询 事件(401-403) ==========
========== EORI有效性查询 事件(501-503) ==========
========== CDS账户校验 事件(601-604) ==========
*/
export const TRACKING_POINT_TYPE = GenerateEnum(
  {
    // ========== LinkSafe 事件 (1-39) ==========
    LINKSAFE_ENTRY_CLICK: {
      id: '1',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_OPEN_PAGE: {
      id: '2',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.openPage',
        text: '打开页面'
      }),
      parentId: '1',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_CLICK_GENERATE_REPORT: {
      id: '3',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.clickGenerateReport',
        text: '点击生成报告'
      }),
      parentId: '2',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_CLICK_REPORT_DETAIL: {
      id: '4',
      label: getLabelText({
        key: 'remote.eventTracking.common.reportDetailPage',
        text: '报告详情页'
      }),
      parentId: '3',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_SHARE_REPORT: {
      id: '5',
      label: getLabelText({
        key: 'remote.eventTracking.common.share',
        text: '分享'
      }),
      parentId: '4',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_DOWNLOAD_REPORT: {
      id: '6',
      label: getLabelText({
        key: 'remote.eventTracking.common.download',
        text: '下载'
      }),
      parentId: '4',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_OPEN_MY_DETECTION: {
      id: '7',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.openMyDetection',
        text: '打开我的检测页面'
      }),
      parentId: '27',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    MILLION_SELLER_CERT_ENTRY_CLICK: {
      id: '1801',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.MILLION_SELLER_CERT
    },
    LINKSAFE_CLICK_VIEW_REPORT: {
      id: '8',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.clickViewReport',
        text: '点击查看报告'
      }),
      parentId: '7',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_CLICK_REPORT_DETAIL_MY_DETECTION: {
      id: '9',
      label: getLabelText({
        key: 'remote.eventTracking.common.reportDetailPage',
        text: '报告详情页'
      }),
      parentId: '8',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_SHARE_REPORT_MY_DETECTION: {
      id: '10',
      label: getLabelText({
        key: 'remote.eventTracking.common.share',
        text: '分享'
      }),
      parentId: '9',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_DOWNLOAD_REPORT_MY_DETECTION: {
      id: '11',
      label: getLabelText({
        key: 'remote.eventTracking.common.download',
        text: '下载'
      }),
      parentId: '9',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_OPEN_SHARE_LINK: {
      id: '12',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.openShareLink',
        text: '打开分享链接'
      }),
      parentId: '',
      hiddenLine: true,
      application: APPLICATION_TYPE.LINK_SAFE
    },
    // 新增LinkSafe事件
    LINKSAFE_APPLICABLE_PRODUCT_CATEGORIES: {
      id: '13',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.applicableProductCategories',
        text: '适用品类'
      }),
      parentId: '12',
      hiddenLine: true,
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_POLICY_STANDARDS: {
      id: '14',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.policyStandards',
        text: '政策标准'
      }),
      parentId: '13',
      hiddenLine: true,
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_UNLIKE_CLICK_GENERATE_REPORT: {
      id: '15',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.unlikeClickGenerateReport',
        text: '非链接生成报告'
      }),
      parentId: '2',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_UNLIKE_CLICK_REPORT_DETAIL_PAGE: {
      id: '16',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.unlikeClickReportDetailPage',
        text: '报告详情页'
      }),
      parentId: '15',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_UNLIKE_SHARE_REPORT_DETAIL_PAGE: {
      id: '17',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.unlikeShareReportDetailPage',
        text: '分享'
      }),
      parentId: '16',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_UNLIKE_DOWNLOAD_REPORT_DETAIL_PAGE: {
      id: '18',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.unlikeDownloadReportDetailPage',
        text: '下载'
      }),
      parentId: '16',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINK_SAFE_CLICK_LOGO: {
      id: '19',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '1',
      application: APPLICATION_TYPE.LINK_SAFE,
      isLogoHome: true
    },
    LINK_SAFE_LOGIN_VIEW_REPORT: {
      id: '20',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.loginViewReport',
        text: '登录查看完整报告'
      }),
      parentId: '4',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINK_SAFE_LOGIN_SUCCESS: {
      id: '21',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.loginSuccess',
        text: '登录成功'
      }),
      parentId: '20',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    // 非链接报告详情--登录查看完整报告
    LINK_SAFE_LOGIN_VIEW_REPORT_BY_NO_LINK: {
      id: '24',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.loginViewReport',
        text: '登录查看完整报告'
      }),
      parentId: '16',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINK_SAFE_LOGIN_SUCCESS_BY_NO_LINK: {
      id: '25',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.loginSuccess',
        text: '登录成功'
      }),
      parentId: '24',
      application: APPLICATION_TYPE.LINK_SAFE
    },

    LINK_SAFE_MY_DETECTION_CLICK: {
      id: '27',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.myDetectionClick',
        text: '点击我的检测'
      }),
      parentId: '1',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINK_SAFE_SHOW_LOGIN_MODAL: {
      id: '28',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.showLoginModal',
        text: '弹出登录弹窗'
      }),
      parentId: '27',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINK_SAFE_MY_DETECTION_LOGIN_SUCCESS: {
      id: '29',
      label: getLabelText({
        key: 'remote.eventTracking.linkSafe.loginSuccess',
        text: '登录成功'
      }),
      parentId: '28',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_HANDLE_NOW: {
      id: '30',
      label: '立即办理',
      parentId: '16',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_ADD_CART: {
      id: '31',
      label: '加入购物车',
      parentId: '30',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_CART_VISIT: {
      id: '32',
      label: '购物车页面访问',
      parentId: '31',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_ORDER_CONFIRM_CART: {
      id: '33',
      label: '订单确认页访问',
      parentId: '32',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_ORDER_DETAIL_CART: {
      id: '34',
      label: '订单详情页访问',
      parentId: '33',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_PAY_COMPLETE_CART: {
      id: '35',
      label: '支付完成',
      parentId: '34',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_BUY_NOW: {
      id: '36',
      label: '立即购买',
      parentId: '30',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_ORDER_CONFIRM_BUY: {
      id: '37',
      label: '订单确认页访问',
      parentId: '36',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_ORDER_DETAIL_BUY: {
      id: '38',
      label: '订单详情页访问',
      parentId: '37',
      application: APPLICATION_TYPE.LINK_SAFE
    },
    LINKSAFE_PAY_COMPLETE_BUY: {
      id: '39',
      label: '支付完成',
      parentId: '38',
      application: APPLICATION_TYPE.LINK_SAFE
    },

    // ==========产品包装标签(产品标签)事件(101-117) ==========
    PRODUCT_TAG_ENTRY_CLICK: {
      id: '101',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_TEMPLATE_VIEW: {
      id: '102',
      label: getLabelText({
        key: 'remote.eventTracking.productTag.templateView',
        text: '标签模板浏览'
      }),
      parentId: '101',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_TEMPLATE_CLICK: {
      id: '103',
      label: getLabelText({
        key: 'remote.eventTracking.common.tagClick',
        text: '标签点击'
      }),
      parentId: '102',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_TEMPLATE_DETAIL_VIEW: {
      id: '104',
      label: getLabelText({
        key: 'remote.eventTracking.productTag.templateDetailView',
        text: '标签详情浏览'
      }),
      parentId: '103',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_TEMPLATE_SAVE_CLICK: {
      id: '105',
      label: getLabelText({
        key: 'remote.eventTracking.common.saveClick',
        text: '保存点击'
      }),
      parentId: '104',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_TEMPLATE_EXPORT_CLICK: {
      id: '106',
      label: getLabelText({
        key: 'remote.eventTracking.common.exportClick',
        text: '导出点击'
      }),
      parentId: '104',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_AI_GENERATE_CLICK: {
      id: '107',
      label: getLabelText({
        key: 'remote.eventTracking.productTag.aiGenerateClick',
        text: '智能生成标签点击'
      }),
      parentId: '102',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_GENERATE_CLICK: {
      id: '108',
      label: getLabelText({
        key: 'remote.eventTracking.productTag.generateClick',
        text: '生成标签点击'
      }),
      parentId: '107',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_AI_SAVE_CLICK: {
      id: '109',
      label: getLabelText({
        key: 'remote.eventTracking.common.saveClick',
        text: '保存点击'
      }),
      parentId: '108',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_AI_EXPORT_CLICK: {
      id: '110',
      label: getLabelText({
        key: 'remote.eventTracking.common.exportClick',
        text: '导出点击'
      }),
      parentId: '108',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_MANUAL_CREATE_CLICK: {
      id: '111',
      label: getLabelText({
        key: 'remote.eventTracking.productTag.manualCreateClick',
        text: '手动创建标签点击'
      }),
      parentId: '102',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_MANUAL_DESIGN_CLICK: {
      id: '112',
      label: getLabelText({
        key: 'remote.eventTracking.productTag.manualDesignClick',
        text: '创建设计点击'
      }),
      parentId: '111',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_MANUAL_SAVE_CLICK: {
      id: '113',
      label: getLabelText({
        key: 'remote.eventTracking.common.saveClick',
        text: '保存点击'
      }),
      parentId: '112',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_MANUAL_EXPORT_CLICK: {
      id: '114',
      label: getLabelText({
        key: 'remote.eventTracking.common.exportClick',
        text: '导出点击'
      }),
      parentId: '112',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_MY_TAG_VIEW: {
      id: '115',
      label: getLabelText({
        key: 'remote.eventTracking.productTag.myTagView',
        text: '我的标签浏览'
      }),
      parentId: '102',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_MY_TAG_CLICK: {
      id: '116',
      label: getLabelText({
        key: 'remote.eventTracking.common.tagClick',
        text: '标签点击'
      }),
      parentId: '115',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_MY_TAG_DETAIL_VIEW: {
      id: '117',
      label: getLabelText({
        key: 'remote.eventTracking.productTag.myTagDetailView',
        text: '标签详情浏览'
      }),
      parentId: '116',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_MY_TAG_SAVE_CLICK: {
      id: '118',
      label: getLabelText({
        key: 'remote.eventTracking.common.saveClick',
        text: '保存点击'
      }),
      parentId: '117',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_TAG_MY_TAG_EXPORT_CLICK: {
      id: '119',
      label: getLabelText({
        key: 'remote.eventTracking.common.exportClick',
        text: '导出点击'
      }),
      parentId: '117',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL
    },
    PRODUCT_PACKAGING_LABEL_CLICK_LOGO: {
      id: '120',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '101',
      application: APPLICATION_TYPE.PRODUCT_PACKAGING_LABEL,
      isLogoHome: true
    },

    // ==========外观检索 事件(201-206) ==========
    EXTERNAL_ORIENTATION_ENTRY_CLICK: {
      id: '201',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.EXTERNAL_ORIENTATION
    },
    EXTERNAL_ORIENTATION_PAGE_VIEW: {
      id: '202',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '201',
      application: APPLICATION_TYPE.EXTERNAL_ORIENTATION
    },
    EXTERNAL_ORIENTATION_GRAPH_SEARCH_VIEW: {
      id: '203',
      label: getLabelText({
        key: 'remote.eventTracking.externalOrientation.graphSearchView',
        text: '图形检索浏览'
      }),
      parentId: '202',
      application: APPLICATION_TYPE.EXTERNAL_ORIENTATION
    },
    EXTERNAL_ORIENTATION_GRAPH_SEARCH_CLICK: {
      id: '204',
      label: getLabelText({
        key: 'remote.eventTracking.externalOrientation.graphSearchClick',
        text: '图形立即检索点击'
      }),
      parentId: '203',
      application: APPLICATION_TYPE.EXTERNAL_ORIENTATION
    },
    EXTERNAL_ORIENTATION_TEXT_SEARCH_VIEW: {
      id: '205',
      label: getLabelText({
        key: 'remote.eventTracking.externalOrientation.textSearchView',
        text: '文字检索浏览'
      }),
      parentId: '202',
      application: APPLICATION_TYPE.EXTERNAL_ORIENTATION
    },
    EXTERNAL_ORIENTATION_TEXT_SEARCH_CLICK: {
      id: '206',
      label: getLabelText({
        key: 'remote.eventTracking.externalOrientation.textSearchClick',
        text: '文字立即检索点击'
      }),
      parentId: '205',
      application: APPLICATION_TYPE.EXTERNAL_ORIENTATION
    },
    EXTERNAL_ORIENTATION_CLICK_LOGO: {
      id: '207',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '201',
      application: APPLICATION_TYPE.EXTERNAL_ORIENTATION,
      isLogoHome: true
    },

    // ========== VAT有效性查询 事件(301-303) ==========
    VAT_VALIDITY_ENTRY_CLICK: {
      id: '301',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.VAT_VALIDITY_CHECK
    },
    VAT_VALIDITY_PAGE_VIEW: {
      id: '302',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '301',
      application: APPLICATION_TYPE.VAT_VALIDITY_CHECK
    },
    VAT_VALIDITY_QUERY_CLICK: {
      id: '303',
      label: getLabelText({
        key: 'remote.eventTracking.common.queryClick',
        text: '查询点击'
      }),
      parentId: '302',
      application: APPLICATION_TYPE.VAT_VALIDITY_CHECK
    },
    VAT_VALIDITY_CHECK_CLICK_LOGO: {
      id: '304',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '301',
      application: APPLICATION_TYPE.VAT_VALIDITY_CHECK,
      isLogoHome: true
    },

    // ========== EPR有效性查询 事件(401-403) ==========
    EPR_VALIDITY_ENTRY_CLICK: {
      id: '401',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.EPR_VALIDITY_CHECK
    },
    EPR_VALIDITY_PAGE_VIEW: {
      id: '402',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '401',
      application: APPLICATION_TYPE.EPR_VALIDITY_CHECK
    },
    EPR_VALIDITY_QUERY_CLICK: {
      id: '403',
      label: getLabelText({
        key: 'remote.eventTracking.common.queryClick',
        text: '查询点击'
      }),
      parentId: '402',
      application: APPLICATION_TYPE.EPR_VALIDITY_CHECK
    },
    EPR_VALIDITY_CHECK_CLICK_LOGO: {
      id: '404',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '401',
      application: APPLICATION_TYPE.EPR_VALIDITY_CHECK,
      isLogoHome: true
    },

    // ========== EORI有效性查询 事件(501-503) ==========
    EORI_VALIDITY_ENTRY_CLICK: {
      id: '501',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.EORI_VALIDITY_CHECK
    },
    EORI_VALIDITY_PAGE_VIEW: {
      id: '502',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '501',
      application: APPLICATION_TYPE.EORI_VALIDITY_CHECK
    },
    EORI_VALIDITY_QUERY_CLICK: {
      id: '503',
      label: getLabelText({
        key: 'remote.eventTracking.common.queryClick',
        text: '查询点击'
      }),
      parentId: '502',
      application: APPLICATION_TYPE.EORI_VALIDITY_CHECK
    },
    EORI_VALIDITY_CHECK_CLICK_LOGO: {
      id: '504',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '501',
      application: APPLICATION_TYPE.EORI_VALIDITY_CHECK,
      isLogoHome: true
    },

    // ========== CDS账户校验 事件(601-604) ==========
    CDS_ENTRY_CLICK: {
      id: '601',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.CDS_ACCOUNT_VALIDATION
    },
    CDS_PAGE_VIEW: {
      id: '602',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '601',
      application: APPLICATION_TYPE.CDS_ACCOUNT_VALIDATION
    },
    CDS_START_CHECK_CLICK: {
      id: '603',
      label: getLabelText({
        key: 'remote.eventTracking.cdsAccount.startCheckClick',
        text: '开始校验点击'
      }),
      parentId: '602',
      application: APPLICATION_TYPE.CDS_ACCOUNT_VALIDATION
    },
    CDS_CONFIRM_CLICK: {
      id: '604',
      label: getLabelText({
        key: 'remote.eventTracking.cdsAccount.confirmClick',
        text: '确定点击'
      }),
      parentId: '603',
      application: APPLICATION_TYPE.CDS_ACCOUNT_VALIDATION
    },
    CDS_ACCOUNT_VALIDATION_CLICK_LOGO: {
      id: '605',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '601',
      application: APPLICATION_TYPE.CDS_ACCOUNT_VALIDATION,
      isLogoHome: true
    },

    // ==========汇率换算 事件(701-703) ==========
    CURRENCY_ENTRY_CLICK: {
      id: '701',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.CURRENCY_EXCHANGE
    },
    CURRENCY_PAGE_VIEW: {
      id: '702',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '701',
      application: APPLICATION_TYPE.CURRENCY_EXCHANGE
    },
    CURRENCY_QUERY_CLICK: {
      id: '703',
      label: getLabelText({
        key: 'remote.eventTracking.common.queryClick',
        text: '查询点击'
      }),
      parentId: '702',
      application: APPLICATION_TYPE.CURRENCY_EXCHANGE
    },
    CURRENCY_EXCHANGE_CLICK_LOGO: {
      id: '704',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '701',
      application: APPLICATION_TYPE.CURRENCY_EXCHANGE,
      isLogoHome: true
    },

    // ==========体验算税（境外） 事件(801-805) ==========
    EXPERIENCE_TAX_OUTSIDE_ENTRY_CLICK: {
      id: '801',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_OUTSIDE
    },
    EXPERIENCE_TAX_OUTSIDE_PAGE_VIEW: {
      id: '802',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '801',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_OUTSIDE
    },
    EXPERIENCE_TAX_OUTSIDE_CALCULATE_CLICK_1: {
      id: '803',
      label: getLabelText({
        key: 'remote.eventTracking.common.startCalculateClick',
        text: '开始算税点击'
      }),
      parentId: '802',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_OUTSIDE
    },
    EXPERIENCE_TAX_OUTSIDE_CLICK_LOGO: {
      id: '806',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '801',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_OUTSIDE,
      isLogoHome: true
    },
    // 这两个没有埋点所以不显示了
    /* EXPERIENCE_TAX_OUTSIDE_DECLARE_CLICK: {
      id: '804',
      label: getLabelText({
        key: 'remote.eventTracking.experienceTaxOutside.declareClick',
        text: '开始申报点击'
      }),
      parentId: '803',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_OUTSIDE
    },
    EXPERIENCE_TAX_OUTSIDE_BUY_SERVICE_CLICK: {
      id: '805',
      label: getLabelText({
        key: 'remote.eventTracking.experienceTaxOutside.buyServiceClick',
        text: '购买服务点击'
      }),
      parentId: '804',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_OUTSIDE
    }, */
    // ==========体验算税（国内） 事件(901-903) ==========
    EXPERIENCE_TAX_INSIDE_ENTRY_CLICK: {
      id: '901',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_INSIDE
    },
    EXPERIENCE_TAX_INSIDE_PAGE_VIEW: {
      id: '902',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '901',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_INSIDE
    },
    EXPERIENCE_TAX_INSIDE_CALCULATE_CLICK: {
      id: '903',
      label: getLabelText({
        key: 'remote.eventTracking.common.startCalculateClick',
        text: '开始算税点击'
      }),
      parentId: '902',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_INSIDE
    },
    EXPERIENCE_TAX_INSIDE_RESULT_VIEW: {
      id: '904',
      label: getLabelText({
        key: 'remote.eventTracking.experienceTaxInside.resultView',
        text: '算税结果页浏览'
      }),
      parentId: '903',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_INSIDE
    },
    EXPERIENCE_TAX_INSIDE_CLICK_LOGO: {
      id: '905',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '901',
      application: APPLICATION_TYPE.EXPERIENCE_TAX_INSIDE,
      isLogoHome: true
    },

    // ==========异常商标查询 事件(1001-1003) ==========
    EXCEPTIONAL_TRADEMARK_ENTRY_CLICK: {
      id: '1001',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.EXCEPTIONAL_TRADEMARK_QUERY
    },
    EXCEPTIONAL_TRADEMARK_PAGE_VIEW: {
      id: '1002',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '1001',
      application: APPLICATION_TYPE.EXCEPTIONAL_TRADEMARK_QUERY
    },
    EXCEPTIONAL_TRADEMARK_QUERY_CLICK: {
      id: '1003',
      label: getLabelText({
        key: 'remote.eventTracking.common.queryClick',
        text: '查询点击'
      }),
      parentId: '1002',
      application: APPLICATION_TYPE.EXCEPTIONAL_TRADEMARK_QUERY
    },
    EXCEPTIONAL_TRADEMARK_QUERY_CLICK_LOGO: {
      id: '1004',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '1001',
      application: APPLICATION_TYPE.EXCEPTIONAL_TRADEMARK_QUERY,
      isLogoHome: true
    },

    // ========== AI商标起名 事件(1101-1107) ==========
    AI_TRADEMARK_ENTRY_CLICK: {
      id: '1101',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.AI_TRADEMARK_NAMING
    },
    AI_TRADEMARK_PAGE_VIEW: {
      id: '1102',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '1101',
      application: APPLICATION_TYPE.AI_TRADEMARK_NAMING
    },
    AI_TRADEMARK_GENERATE_CLICK: {
      id: '1103',
      label: getLabelText({
        key: 'remote.eventTracking.aiTrademarkNaming.generateClick',
        text: '立即起名点击'
      }),
      parentId: '1102',
      application: APPLICATION_TYPE.AI_TRADEMARK_NAMING
    },
    AI_TRADEMARK_RE_GENERATE_CLICK: {
      id: '1104',
      label: getLabelText({
        key: 'remote.eventTracking.aiTrademarkNaming.reGenerateClick',
        text: '重新起名点击'
      }),
      parentId: '1103',
      application: APPLICATION_TYPE.AI_TRADEMARK_NAMING
    },
    AI_TRADEMARK_REGISTER_CLICK: {
      id: '1105',
      label: getLabelText({
        key: 'remote.eventTracking.aiTrademarkNaming.registerClick',
        text: '立即注册点击'
      }),
      parentId: '1104',
      application: APPLICATION_TYPE.AI_TRADEMARK_NAMING
    },
    AI_TRADEMARK_FREE_SEARCH_CLICK: {
      id: '1106',
      label: getLabelText({
        key: 'remote.eventTracking.aiTrademarkNaming.freeSearchClick',
        text: '免费检索点击'
      }),
      parentId: '1102',
      application: APPLICATION_TYPE.AI_TRADEMARK_NAMING
    },
    AI_TRADEMARK_SEARCH_CLICK: {
      id: '1107',
      label: getLabelText({
        key: 'remote.eventTracking.common.searchClick',
        text: '搜索点击'
      }),
      parentId: '1106',
      application: APPLICATION_TYPE.AI_TRADEMARK_NAMING
    },
    AI_TRADEMARK_CLICK_LOGO: {
      id: '1108',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '1101',
      application: APPLICATION_TYPE.AI_TRADEMARK_NAMING,
      isLogoHome: true
    },

    // ==========分类查询 事件(1201-1204) ==========
    CLASSIFICATION_ENTRY_CLICK: {
      id: '1201',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.CLASSIFICATION_QUERY
    },
    CLASSIFICATION_PAGE_VIEW: {
      id: '1202',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '1201',
      application: APPLICATION_TYPE.CLASSIFICATION_QUERY
    },
    CLASSIFICATION_QUERY_CLICK: {
      id: '1203',
      label: getLabelText({
        key: 'remote.eventTracking.classificationQuery.queryClick',
        text: '分类点击查询'
      }),
      parentId: '1202',
      application: APPLICATION_TYPE.CLASSIFICATION_QUERY
    },
    CLASSIFICATION_FREE_QUERY_CLICK: {
      id: '1204',
      label: getLabelText({
        key: 'remote.eventTracking.classificationQuery.freeQueryClick',
        text: '免费查询点击'
      }),
      parentId: '1202',
      application: APPLICATION_TYPE.CLASSIFICATION_QUERY
    },
    CLASSIFICATION_QUERY_CLICK_LOGO: {
      id: '1205',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '1201',
      application: APPLICATION_TYPE.CLASSIFICATION_QUERY,
      isLogoHome: true
    },

    // ==========美国商标宣誓查询 事件(1301-1304) ==========
    US_TRADEMARK_ENTRY_CLICK: {
      id: '1301',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.US_TRADEMARK_QUERY
    },
    US_TRADEMARK_PAGE_VIEW: {
      id: '1302',
      label: getLabelText({
        key: 'remote.eventTracking.common.pageView',
        text: '页面浏览'
      }),
      parentId: '1301',
      application: APPLICATION_TYPE.US_TRADEMARK_QUERY
    },
    US_TRADEMARK_QUERY_CLICK: {
      id: '1303',
      label: getLabelText({
        key: 'remote.eventTracking.common.queryClick',
        text: '查询点击'
      }),
      parentId: '1302',
      application: APPLICATION_TYPE.US_TRADEMARK_QUERY
    },
    US_TRADEMARK_BUY_CLICK: {
      id: '1304',
      label: getLabelText({
        key: 'remote.eventTracking.usTrademark.buyClick',
        text: '立即购买点击'
      }),
      parentId: '1303',
      application: APPLICATION_TYPE.US_TRADEMARK_QUERY
    },
    US_TRADEMARK_CLICK_LOGO: {
      id: '1305',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '1301',
      application: APPLICATION_TYPE.US_TRADEMARK_QUERY,
      isLogoHome: true
    },

    // ==========商标查询 事件(1401-1499) ==========
    TRADEMARK_QUERY_ENTRY_CLICK: {
      id: '1401',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_FREE_SEARCH_CLICK: {
      id: '1402',
      label: getLabelText({
        key: 'remote.eventTracking.common.freeSearchClick',
        text: '免费检索点击'
      }),
      parentId: '1401',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_FREE_SEARCH_SECOND_CLICK: {
      id: '1403',
      label: getLabelText({
        key: 'remote.eventTracking.common.freeSearchSecondClick',
        text: '免费检索点击-二次点击'
      }),
      parentId: '1402',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_MANUAL_CHECK_CLICK: {
      id: '1404',
      label: getLabelText({
        key: 'remote.eventTracking.common.manualCheckClick',
        text: '人工核名点击'
      }),
      parentId: '1402',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_SUBMIT_CLICK: {
      id: '1405',
      label: getLabelText({
        key: 'remote.eventTracking.common.submitClick',
        text: '提交点击'
      }),
      parentId: '1404',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_CONTINUE_SUBMIT_CLICK: {
      id: '1406',
      label: getLabelText({
        key: 'remote.eventTracking.common.continueSubmitClick',
        text: '继续提交点击'
      }),
      parentId: '1405',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_SEARCH_CLICK: {
      id: '1407',
      label: getLabelText({
        key: 'remote.eventTracking.common.searchClick',
        text: '搜索点击'
      }),
      parentId: '1402',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_BATCH_SEARCH_CLICK: {
      id: '1409',
      label: getLabelText({
        key: 'remote.eventTracking.common.batchSearchClick',
        text: '批量检索点击'
      }),
      parentId: '1401',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_IMPORT_TABLE_CLICK: {
      id: '1410',
      label: getLabelText({
        key: 'remote.eventTracking.common.importTableClick',
        text: '导入表格点击'
      }),
      parentId: '1409',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_MANUAL_INPUT_CLICK: {
      id: '1411',
      label: getLabelText({
        key: 'remote.eventTracking.common.manualInputClick',
        text: '手动输入点击'
      }),
      parentId: '1409',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_IMPORT_TABLE_BATCH_SEARCH_SUBMIT: {
      id: '1412',
      label: getLabelText({
        key: 'remote.eventTracking.common.batchSearchSubmit',
        text: '批量检索提交'
      }),
      parentId: '1410',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_IMPORT_TABLE_BATCH_RESULT_VIEW: {
      id: '1413',
      label: getLabelText({
        key: 'remote.eventTracking.common.batchResultView',
        text: '批量结果查看'
      }),
      parentId: '1412',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_IMPORT_TABLE_SINGLE_RESULT_VIEW: {
      id: '1414',
      label: getLabelText({
        key: 'remote.eventTracking.common.singleResultView',
        text: '查看单条结果'
      }),
      parentId: '1413',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_MANUAL_INPUT_BATCH_SEARCH_SUBMIT: {
      id: '1415',
      label: getLabelText({
        key: 'remote.eventTracking.common.batchSearchSubmit',
        text: '批量检索提交'
      }),
      parentId: '1411',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_MANUAL_INPUT_BATCH_RESULT_VIEW: {
      id: '1416',
      label: getLabelText({
        key: 'remote.eventTracking.common.batchResultView',
        text: '批量结果查看'
      }),
      parentId: '1415',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_MANUAL_INPUT_SINGLE_RESULT_VIEW: {
      id: '1417',
      label: getLabelText({
        key: 'remote.eventTracking.common.singleResultView',
        text: '查看单条结果'
      }),
      parentId: '1416',
      application: APPLICATION_TYPE.TRADEMARK_QUERY
    },
    TRADEMARK_QUERY_CLICK_LOGO: {
      id: '1408',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '1401',
      application: APPLICATION_TYPE.TRADEMARK_QUERY,
      isLogoHome: true
    },

    // ==========香港公司核名 事件(1501-1599) ==========
    HK_COMPANY_NAME_CHECK_ENTRY_CLICK: {
      id: '1501',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_QUERY_CLICK: {
      id: '1502',
      label: getLabelText({
        key: 'remote.eventTracking.common.queryClick',
        text: '查询点击'
      }),
      parentId: '1501',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_REQUERY_CLICK: {
      id: '1503',
      label: getLabelText({
        key: 'remote.eventTracking.common.requeryClick',
        text: '重新查询点击'
      }),
      parentId: '1502',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_REGISTER_CLICK: {
      id: '1504',
      label: getLabelText({
        key: 'remote.eventTracking.common.registerClick',
        text: '立即注册点击'
      }),
      parentId: '1502',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_SERVICE_VISIT: {
      id: '1505',
      label: getLabelText({
        key: 'remote.eventTracking.common.serviceVisit',
        text: '购买服务访问'
      }),
      parentId: '1504',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_PRODUCT_DETAIL_VISIT: {
      id: '1506',
      label: getLabelText({
        key: 'remote.eventTracking.common.productDetailVisit',
        text: '商品详情页访问'
      }),
      parentId: '1505',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_ORDER_CONFIRM_PRODUCT: {
      id: '1507',
      label: getLabelText({
        key: 'remote.eventTracking.common.orderConfirmVisit',
        text: '订单确认页访问'
      }),
      parentId: '1506',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_ORDER_DETAIL_PRODUCT: {
      id: '1508',
      label: getLabelText({
        key: 'remote.eventTracking.common.orderDetailVisit',
        text: '订单详情页访问'
      }),
      parentId: '1507',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_PAY_COMPLETE_PRODUCT: {
      id: '1509',
      label: getLabelText({
        key: 'remote.eventTracking.common.payComplete',
        text: '支付完成'
      }),
      parentId: '1508',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_CART_VISIT_PRODUCT: {
      id: '1510',
      label: getLabelText({
        key: 'remote.eventTracking.common.cartVisitProduct',
        text: '购物车访问'
      }),
      parentId: '1506',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_ORDER_CONFIRM_CART_PRODUCT: {
      id: '1511',
      label: getLabelText({
        key: 'remote.eventTracking.common.orderConfirmVisit',
        text: '订单确认页访问'
      }),
      parentId: '1510',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_ORDER_DETAIL_CART_PRODUCT: {
      id: '1512',
      label: getLabelText({
        key: 'remote.eventTracking.common.orderDetailVisit',
        text: '订单详情页访问'
      }),
      parentId: '1511',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_PAY_COMPLETE_CART_PRODUCT: {
      id: '1513',
      label: getLabelText({
        key: 'remote.eventTracking.common.payComplete',
        text: '支付完成'
      }),
      parentId: '1512',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_ORDER_CONFIRM_VISIT: {
      id: '1514',
      label: getLabelText({
        key: 'remote.eventTracking.common.orderConfirmVisit',
        text: '订单确认页访问'
      }),
      parentId: '1505',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_ORDER_DETAIL_VISIT: {
      id: '1515',
      label: getLabelText({
        key: 'remote.eventTracking.common.orderDetailVisit',
        text: '订单详情页访问'
      }),
      parentId: '1514',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_PAY_COMPLETE: {
      id: '1516',
      label: getLabelText({
        key: 'remote.eventTracking.common.payComplete',
        text: '支付完成'
      }),
      parentId: '1515',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_CART_VISIT: {
      id: '1517',
      label: getLabelText({
        key: 'remote.eventTracking.common.cartVisit',
        text: '购物车页面访问'
      }),
      parentId: '1505',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_ORDER_CONFIRM_CART: {
      id: '1518',
      label: getLabelText({
        key: 'remote.eventTracking.common.orderConfirmVisit',
        text: '订单确认页访问'
      }),
      parentId: '1517',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_ORDER_DETAIL_CART: {
      id: '1519',
      label: getLabelText({
        key: 'remote.eventTracking.common.orderDetailVisit',
        text: '订单详情页访问'
      }),
      parentId: '1518',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_PAY_COMPLETE_CART: {
      id: '1520',
      label: getLabelText({
        key: 'remote.eventTracking.common.payComplete',
        text: '支付完成'
      }),
      parentId: '1519',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION
    },
    HK_COMPANY_NAME_CHECK_CLICK_LOGO: {
      id: '1521',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '1501',
      application: APPLICATION_TYPE.HKCOMPANY_NAME_VERIFICATION,
      isLogoHome: true
    },

    // ==========亚马逊绿标查询 事件(1601-1699) ==========
    AMAZON_GREEN_LABEL_QUERY_CLICK: {
      id: '1601',
      label: getLabelText({
        key: 'remote.eventTracking.common.entryClick',
        text: '入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.AMAZON_GREEN_LABEL_QUERY
    },
    AMAZON_GREEN_LABEL_QUERY_CLICK_LOGO: {
      id: '1602',
      label: getLabelText({
        key: 'remote.eventTracking.common.clickLogo',
        text: '平台logo点击'
      }),
      parentId: '1601',
      application: APPLICATION_TYPE.AMAZON_GREEN_LABEL_QUERY,
      isLogoHome: true
    },

    // ========== 小O首页事件(1701-1799) ==========
    // 需求定义入口1为右侧悬浮小O，入口2为顶部小O智能助手，编号需保持前后端一致。
    XIAO_O_FLOATING_EXPOSURE: {
      id: '1701',
      label: getLabelText({
        key: 'remote.eventTracking.xiaoO.floatingExposure',
        text: '入口1曝光'
      }),
      parentId: '',
      application: APPLICATION_TYPE.XIAO_O
    },
    XIAO_O_HEADER_EXPOSURE: {
      id: '1702',
      label: getLabelText({
        key: 'remote.eventTracking.xiaoO.headerExposure',
        text: '入口2曝光'
      }),
      parentId: '',
      application: APPLICATION_TYPE.XIAO_O
    },
    XIAO_O_FLOATING_CLICK: {
      id: '1703',
      label: getLabelText({
        key: 'remote.eventTracking.xiaoO.floatingClick',
        text: '入口1点击'
      }),
      parentId: '1701',
      application: APPLICATION_TYPE.XIAO_O
    },
    XIAO_O_HEADER_CLICK: {
      id: '1704',
      label: getLabelText({
        key: 'remote.eventTracking.xiaoO.headerClick',
        text: '入口2点击'
      }),
      parentId: '1702',
      application: APPLICATION_TYPE.XIAO_O
    },
    XIAO_O_FLOATING_PAGE_OPEN_SUCCESS: {
      id: '1705',
      label: getLabelText({
        key: 'remote.eventTracking.xiaoO.floatingPageOpenSuccess',
        text: '入口1进入对话页成功'
      }),
      parentId: '1703',
      application: APPLICATION_TYPE.XIAO_O
    },
    XIAO_O_HEADER_PAGE_OPEN_SUCCESS: {
      id: '1706',
      label: getLabelText({
        key: 'remote.eventTracking.xiaoO.headerPageOpenSuccess',
        text: '入口2进入对话页成功'
      }),
      parentId: '1704',
      application: APPLICATION_TYPE.XIAO_O
    },
    // 1707—1718 仍供小O业务流程采集使用，但不恢复已回撤的应用分析树节点。
    XIAO_O_QUESTION_SENT: {
      id: '1707',
      label: '提问发送成功',
      parentId: '',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_AGENT_FINAL_REPLY: {
      id: '1708',
      label: 'Agent最终回复完成',
      parentId: '1707',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_PRODUCT_EXPOSURE: {
      id: '1709',
      label: '商品曝光',
      parentId: '',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_PRODUCT_SPEC_CONFIRMED: {
      id: '1710',
      label: '商品规格确认',
      parentId: '1709',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_BUY_NOW_EXPOSURE: {
      id: '1711',
      label: '立即购买按钮曝光',
      parentId: '',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_BUY_NOW_CLICK: {
      id: '1712',
      label: '立即购买点击',
      parentId: '1711',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_ORDER_CONFIRMATION_EXPOSURE: {
      id: '1713',
      label: '购买确认卡曝光',
      parentId: '1712',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_ORDER_SUBMIT_SUCCESS: {
      id: '1714',
      label: '提交订单成功',
      parentId: '1713',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_INVOICE_CHANGE_SUCCESS: {
      id: '1715',
      label: '发票信息修改成功',
      parentId: '1713',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_INVOICE_MAINTAIN_CLICK: {
      id: '1716',
      label: '前往维护发票信息',
      parentId: '1713',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_ORDER_CANCEL_SUCCESS: {
      id: '1717',
      label: 'AI来源订单取消成功',
      parentId: '1714',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    XIAO_O_PAYMENT_SUCCESS: {
      id: '1718',
      label: '完成付款',
      parentId: '1714',
      application: APPLICATION_TYPE.XIAO_O,
      analysisVisible: false
    },
    // ========== 在线咨询事件(1901-1999) ==========
    ONLINE_CONSULTATION_CUSTOMER_SERVICE_CLICK: {
      id: '1901',
      label: getLabelText({
        key: 'remote.eventTracking.onlineConsultation.customerServiceClick',
        text: '客服入口点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.ONLINE_CONSULTATION
    },

    // ==========平台登录 事件(10000) ==========
    LOGIN: {
      id: '10000',
      label: getLabelText({
        key: 'remote.eventTracking.common.platformLogin',
        text: '平台登录'
      }),
      parentId: '',
      application: APPLICATION_TYPE.LOGIN
    },

    // ==========应用中心点击 事件(10001) ==========
    APP_CLICK: {
      id: '10001',
      label: getLabelText({
        key: 'remote.eventTracking.common.appCenterClick',
        text: '应用中心点击'
      }),
      parentId: '',
      application: APPLICATION_TYPE.APP_CLICK
    },

  },
  'id'
)

/**
 * 根据应用类型生成树结构
 * @param {*} application - 应用类型
 * @returns {Array} 构建好的树结构数组
 */
export function genrateTreeByApplication(application) {
  // 运行时埋点仍需保留统一事件映射，但已回撤的节点不能重新出现在应用分析树中。
  const items = TRACKING_POINT_TYPE.enumArray.filter((item) => item.application === application && item.analysisVisible !== false)
  return buildTrackingPointTree(items)
}

// 小O各入口与埋点动作的统一映射，保证曝光、点击和打开成功始终归属同一入口。
const XIAO_O_TRACKING_POINT_MAP = {
  [XIAO_O_ENTRY_SOURCE.HEADER]: {
    [XIAO_O_TRACKING_ACTION.EXPOSURE]: TRACKING_POINT_TYPE.XIAO_O_HEADER_EXPOSURE,
    [XIAO_O_TRACKING_ACTION.CLICK]: TRACKING_POINT_TYPE.XIAO_O_HEADER_CLICK,
    [XIAO_O_TRACKING_ACTION.PAGE_OPEN_SUCCESS]: TRACKING_POINT_TYPE.XIAO_O_HEADER_PAGE_OPEN_SUCCESS
  },
  [XIAO_O_ENTRY_SOURCE.FLOATING]: {
    [XIAO_O_TRACKING_ACTION.EXPOSURE]: TRACKING_POINT_TYPE.XIAO_O_FLOATING_EXPOSURE,
    [XIAO_O_TRACKING_ACTION.CLICK]: TRACKING_POINT_TYPE.XIAO_O_FLOATING_CLICK,
    [XIAO_O_TRACKING_ACTION.PAGE_OPEN_SUCCESS]: TRACKING_POINT_TYPE.XIAO_O_FLOATING_PAGE_OPEN_SUCCESS
  }
}

/**
 * 根据小O入口来源和动作获取埋点事件编号。
 * @param {string} source 入口来源
 * @param {string} action 埋点动作
 * @returns {string|undefined} 对应事件编号，未知来源或动作返回 undefined
 */
export function getXiaoOTrackingPoint(source, action) {
  return XIAO_O_TRACKING_POINT_MAP[source] && XIAO_O_TRACKING_POINT_MAP[source][action]
}

export const MDT_PRO_TRACKING_POINT_TYPE = GenerateEnum(
  {
    ENTRANCE_CLICK: {
      id: '-1',
      label: '入口点击',
      parentId: '',
    },
    IP_OVERVIEW: {
      id: '1',
      label: '知产总览',
      parentId: '-1',
    },
    QUERY_ENTRY_CLICK: {
      id: '2',
      label: '查询入口点击',
      parentId: '1',
    },
    WORK_BENCH: {
      id: '3',
      label: '工作台',
      parentId: '-1',
    },
    CLICK_TRADEMARK_SEARCH: {
      id: '4',
      label: '点击商标检索',
      parentId: '3',
    },
    CLICK_DESIGN_SEARCH: {
      id: '5',
      label: '点击外观检索',
      parentId: '3',
    },
    CLICK_AI_TRADEMARK_NAMING: {
      id: '6',
      label: '点击AI商标起名',
      parentId: '3',
    },
    CLICK_TRADEMARK_CLASSIFICATION_QUERY: {
      id: '7',
      label: '点击商标分类查询',
      parentId: '3',
    },
    CLICK_TRADEMARK_DECLARATION_QUERY: {
      id: '8',
      label: '点击商标宣誓查询',
      parentId: '3',
    },
    CLICK_ABNORMAL_TRADEMARK_QUERY: {
      id: '9',
      label: '点击异常商标查询',
      parentId: '3',
    },
    CLICK_PENDING_TASK_OPERATION: {
      id: '10',
      label: '点击待办事项操作',
      parentId: '3',
    },
    COMPLIANCE_ASSETS: {
      id: '11',
      label: '合规资产',
      parentId: '-1',
    },
    COMPLIANCE_CALENDAR: {
      id: '12',
      label: '合规日历',
      parentId: '-1',
    },
    CLICK_CREATE_ITEM: {
      id: '13',
      label: '点击创建事项',
      parentId: '12',
    },
    TRADEMARK_MONITORING: {
      id: '14',
      label: '商标监控',
      parentId: '-1',
    },
    ALL_REMINDERS: {
      id: '15',
      label: '全部提醒',
      parentId: '14',
    },
    EXPIRATION_REMINDER_VIEW_ALL: {
      id: '16',
      label: '到期提醒_查看全部',
      parentId: '15',
    },
    EXPIRATION_REMINDER_OPERATION: {
      id: '17',
      label: '到期提醒_操作',
      parentId: '15',
    },
    COMPLIANCE_REMINDER_VIEW_ALL: {
      id: '18',
      label: '合规提醒_查看全部',
      parentId: '15',
    },
    COMPLIANCE_REMINDER_VIEW: {
      id: '19',
      label: '合规提醒_查看',
      parentId: '15',
    },
    COMPLIANCE_REMINDER_PROCESS: {
      id: '20',
      label: '合规提醒_处理',
      parentId: '15',
    },
    RISK_TRADEMARK_VIEW_ALL: {
      id: '21',
      label: '被抢注风险_查看全部',
      parentId: '15',
    },
    HIGH_RISK_OF_SQUATTING_VIEW: {
      id: '22',
      label: '被抢注风险_查看',
      parentId: '15',
    },
    HIGH_RISK_OF_SQUATTING_PROCESS: {
      id: '23',
      label: '被抢注风险_处理',
      parentId: '15',
    },
    EXPIRATION_REMINDER: {
      id: '24',
      label: '到期提醒',
      parentId: '14',
    },
    EXPIRATION_REMINDER_CLICK_OPERATION: {
      id: '25',
      label: '点击操作',
      parentId: '24',
    },
    COMPLIANCE_REMINDER: {
      id: '26',
      label: '合规提醒',
      parentId: '14',
    },
    COMPLIANCE_REMINDER_CLICK_VIEW: {
      id: '27',
      label: '点击查看',
      parentId: '26',
    },
    COMPLIANCE_REMINDER_CLICK_IGNORE: {
      id: '28',
      label: '点击忽略',
      parentId: '26',
    },
    HIGH_RISK_OF_SQUATTING: {
      id: '29',
      label: '被抢注风险',
      parentId: '14',
    },
    HIGH_RISK_OF_SQUATTING_CLICK_VIEW: {
      id: '30',
      label: '点击查看',
      parentId: '29',
    },
    HIGH_RISK_OF_SQUATTING_CLICK_IGNORE: {
      id: '31',
      label: '点击忽略',
      parentId: '29',
    },
    CLICK_EXCLUSIVE_CUSTOMER_SERVICE_MANAGER: {
      id: '32',
      label: '点击专属客服经理',
      parentId: '',
    },
  },
  'id'
)

/**
 * mdtPrp生成树结构
 * @returns {Array} 构建好的树结构数组
 */
export function genrateTreeByMdtPro() {
  const items = MDT_PRO_TRACKING_POINT_TYPE.enumArray
  return buildTrackingPointTree(items)
}

/**
 * 根据TRACKING_POINT_TYPE构建树结构
 * @param {Array} items - TRACKING_POINT_TYPE枚举对象的数组
 * @returns {Array} 构建好的树结构数组
 */
export function buildTrackingPointTree(items = []) {
  // 创建id到节点的映射，方便查找父节点
  const idMap = {}

  // 创建根节点数组
  const rootNodes = []

  // 第一步：将所有节点添加到映射中
  items.forEach((item) => {
    idMap[item.id] = {
      ...item,
      value: 0, // 初始值设为0
      children: []
    }
  })

  // 第二步：构建树结构
  items.forEach((item) => {
    const currentNode = idMap[item.id]

    if (item.parentId === '') {
      // 根节点
      rootNodes.push(currentNode)
    } else {
      // 非根节点，添加到父节点的children数组中
      const parentNode = idMap[item.parentId]
      if (parentNode) {
        parentNode.children.push(currentNode)
      }
    }
  })

  return rootNodes
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/applicationManage.js